import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { IExam } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-template-download',
  templateUrl: './template-download.component.html',
  styleUrls: ['./template-download.component.scss']
})
export class TemplateDownloadComponent implements OnInit {
  exam: IExam = examDefault;
  fileName: string = "";
  filePath: string = "";
  template: string = "";
  questionFormat: string = "Format1";

  @ViewChild('tempDownload') downloadBtn: ElementRef;

  constructor(private popoverRef: PopoverRef<TemplateDownloadComponent>,
    private examsevice: ExamService, private snackBar: SnackbarService,) { }

  ngOnInit() {
    
    if (this.examsevice.selectedExams.length === 1) {
      this.exam = this.examsevice.selectedExams[0];
    }
  }

  onTemplateSelected() {
    
    switch (this.template) {
      case "QU":
        this.fileName = 'Question_Upload_Format_1.txt';
        this.filePath = '/assets/templates/Question_Upload_Format_1.txt';
        break;
      // case "QCU":
      //   console.log("It is a Monday.");
      //   break;
      case "ECE":
        this.fileName = 'Exam_Candidates_Export.xlsx';
        this.filePath = '/assets/templates/Exam_Candidates_Export.xlsx';
        break;
        case "CES":
          this.fileName = 'Candidate_Examination_Schedule.xlsx';
          this.filePath = '/assets/templates/CandidateExaminationScheduleTemplate.xlsx';
        break;
      case "IPFE":
        this.fileName = 'Import Passwords From Excel.xlsx';
        this.filePath = '/assets/templates/ImportPasswordsFromExcel.xlsx';
          break;
      default:
        console.log("No such template exists!");
        break;
    }


  }

  onFormartSelected() {
    
    switch (this.questionFormat) {
      case "Format1":
        this.fileName = 'Question_Upload_Format_1.txt';
        this.filePath = '/assets/templates/Question_Upload_Format_1.txt';
        break;
      case "Format2":
        this.fileName = 'Question_Upload_Format_2.txt';
        this.filePath = '/assets/templates/Question_Upload_Format_2.txt';
        break;
      case "Excel":
        this.fileName = 'Question Format.xlsx';
        this.filePath = '/assets/templates/Question Format.xlsx';
        break;
      default:
        this.snackBar.error("No such template exists!");
        console.log("No such template exists!");
        break;
    }


  }

  downloadTemplate() {
    const link = document.createElement('a');
    link.setAttribute('href', this.filePath);
    link.setAttribute('download', this.fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }


  close() {
    this.popoverRef.close();
  }

}
